<template>

  <ul class="nav ">
    <li v-for="menu in menuList">
      <router-link :to="{ name : 'Home'}">
        <i class="fa fa-th-large"></i> <span class="nav-label">{{menu.name}}</span>aaa
      </router-link>
        vv<router-link :to="menu.link"><i class="fa fa-th-large"></i> <span class="nav-label">{{menu.name}}</span>
        </router-link>
    </li>
  </ul>

</template>

<script>
  export default {
    data () {
      return {
        menuList: [
          {name: '管理トップa', link: '/'},
          {name: '会社管理', link: '/company/'},
          {name: '会社グループ', link: '/company/group/'},
          {name: '請求グループ', link: '/bill/group'},
          {name: '応募管理', link: '/apply/'},
          {name: '会員管理', link: '/member/'}
        ]
      }
    }
  }
</script>




// WEBPACK FOOTER //
// SideMenu.vue?0b47f742